import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    activityText: {
        marginLeft: '0.5rem'
    },
    ectivityTextHeader: {
        fontWeight: 600
    },
    dialogWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    dialogTitle: {
        fontSize: '1.1rem',
        marginRight: '3rem'
    },
    downloadButton: {
        padding: '0.7rem',
    },
    downloadButtonWrapper: {
        textAlign: 'right',
        marginTop: '3px',
        marginBottom: '10px'
    },
    activityIdLists: {
        maxHeight:'350px',
        overflow:'auto',
        marginBottom:'10px',
        gap: '.5em',
        flexWrap: 'nowrap'
    },
    dialog: {
        maxWidth: '100%',
        width: 2000
    },
    directions: {
        fontWeight: 'bold',
        paddingLeft: '.5em'
    },
    box: {
        background: theme.palette.neutral.light,
        border: '1px solid lightGrey',
        borderRadius: '3px',
        padding: '5px',
        overflow:'auto'
    },
    activityGroupHeader: {
        fontWeight: 'bold',
        paddingBottom: 0
    },
    materialItem: {
        paddingLeft: '32px',
        paddingTop: 4,
        paddingBottom: 4
    },
    materialNote: {
        paddingLeft: '.5em',
        paddingRight: '.5em',
        marginTop: '8px',
        marginBottom: '8px',
        fontStyle: 'italic',
        fontSize: '0.9em',
        color: '#666'
    },
    importDialogPaper: {
        width: '80vw',
        minHeight: '75vh',
        maxHeight: '90vh'
    }
}));
